var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-md navbar-light bg-white shadow-sm"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/home"}},[_vm._v("MAX'Bx 電力監測系統 "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_dev),expression:"is_dev"}]},[_vm._v(" - 工程版")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }